<template>
  <!-- 企业项目空间 - 某个项目详情页 - 回收站 author: zhangxiaofeng-->
  <!--<div class="enterprise-recycle">-->
    <!--<recycle-bin for-space-enterprise></recycle-bin>-->
  <!--</div>-->
  <recycle-bin for-space-enterprise></recycle-bin>
</template>
<script>
import RecycleBin from '_c/common/RecycleBin'
export default {
  name: 'ProjectRecycle',
  components: {
    RecycleBin
  },
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {}
  }
}
</script>
